export const colors = {
  background: 'white',

  primary: '#555555',
  primaryLight: '#717171',
  primaryText: 'white',

  circleBlue: '#3589ef',
  white: '#FFFFFF',

  red: '#EF5350',
  yellow: '#F7D23C',
  darkBlue: '#0E126C',
  lightBlue: '#00BFFF',
  blue: '#3589EB',
  green: '#78C698',
  azure: '#2DD3EF',
  purple: '#202C76',
  darkPurple: '#10184D',
  backgroundLight: '#F6F7F8',
  text: '#454D57',
  textLight: '#454D5766',
  borderLight: '#91919126',
  grey: '#F4F4F4',

  achorTagBlue: '#3273DC',
  lightTextColor: '#707070',
  textColor: '#3E3E3E',
  lightGreyColor: '#A7A7A7',
  lightSkyBlue: '#13BEB1',
  selectedColor: '#3599F8',
  popup_background: '#FFFFFF',
  create_mouseover: '#3599F8',
  textcolor: '#3E3E3E',
  lightgreycolor: '#A7A7A7',
  greencolor: '#7AC142',
  darkblue: '#3584BE',
  whitecolor: '#FFFFFF',
  primarybakground: '#3599F8',
  tealBlue: '#13BEB1',
};
